import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useCopyToClipboard = () => {
  const { t } = useTranslation();

  return useCallback(
    async (text: string) => {
      await navigator.clipboard.writeText(text);
      toast.success(t("common.copiedToClipboard"), { autoClose: 3000 });
    },
    [t],
  );
};

export default useCopyToClipboard;
